import React from 'react';
import {AutoComplete, Button, Divider, Input, InputNumber, message, Modal, Popconfirm, Select, Table, Tabs} from "antd";
import Axios from "../../../utils/axios";
import PATH_URL from "../../../utils/url";
import SiteSettleManageInfo from "../siteSettle/SiteSettleManageInfo";

class BookkeepingManageInfo extends React.Component {
    state = {
        activeTab: 'entry',
        // 流水录入
        year: null,
        month: null,
        income: [],        // [{incomeRole,label,count,amount}]
        expenses: [],      // [{id,category,amount,remark}]
        incomeTotal: 0,
        expenseTotal: 0,
        net: 0,
        // 支出新增表单
        expCategory: '',
        expCategoryOptions: [],   // 历史支出类别（按使用频率倒序）
        expAmount: null,
        expRemark: '',
        // 支出筛选（流水录入-手输）
        expFilterCategory: '',
        expFilterRemark: '',
        // 支出编辑弹窗
        editVisible: false,
        editId: null,
        editYear: null,
        editMonth: null,
        editCategory: '',
        editAmount: null,
        editRemark: '',
        // 流水录入当月汇总（复用 renderMonthly 结构）
        entrySummary: null,
        // 汇总支出类别筛选
        monthlyExpCatFilter: '',
        annualYear: null,
        annual: null,
        // 年报表支出明细筛选（手输）
        annualExpFilter: '',
        // 年报表收入角色筛选
        annualIncFilter: '',
        // 年报表月份明细弹窗
        annualDetailVisible: false,
        annualDetailMonth: null,
        // 权限
        userPermission: [],
    };

    componentDidMount() {
        this.loadUserPermission();
        this.loadExpenseCategories();
        let now = new Date();
        this.setState({
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            annualYear: now.getFullYear(),
        }, () => {
            this.loadMonthData();
        });
    }

    loadUserPermission = () => {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        Axios({
            method: 'get',
            url: '/menu/getUserMenu/' + userName,
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({userPermission: res.data.data || []});
            }
        }).catch(err => console.log(err));
    };

    hasPerm = (code) => {
        return this.state.userPermission != null && this.state.userPermission.includes(code);
    };

    loadExpenseCategories = () => {
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_EXPENSE_CATEGORIES_URL,
        }).then(res => {
            if (res.data.code === 200) {
                let arr = (res.data.data || []).map(c => ({value: c}));
                this.setState({expCategoryOptions: arr});
            }
        }).catch(err => console.log(err));
    };

    loadMonthData = () => {
        let {year, month} = this.state;
        if (!year || !month) return;
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_MONTH_DATA_URL,
            params: {year, month},
        }).then(res => {
            if (res.data.code === 200) {
                let d = res.data.data || {};
                this.setState({
                    income: d.income || [],
                    expenses: d.expenses || [],
                    incomeTotal: d.incomeTotal || 0,
                    expenseTotal: d.expenseTotal || 0,
                    net: d.net || 0,
                }, this.loadEntrySummary);
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    loadEntrySummary = () => {
        let {year, month} = this.state;
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_MONTHLY_REPORT_URL,
            params: {year, month},
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({entrySummary: res.data.data});
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    saveIncome = (row) => {
        let {year, month} = this.state;
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_INCOME_SAVE_URL,
            params: {
                year, month,
                incomeRole: row.incomeRole,
                count: row.count,
                amount: row.amount,
            },
        }).then(res => {
            if (res.data.code === 200) {
                message.success("保存成功");
                this.loadMonthData();
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    updateIncomeField = (role, field, value) => {
        let income = this.state.income.map(r => r.incomeRole === role ? {...r, [field]: value} : r);
        this.setState({income});
    };

    addExpense = () => {
        let {year, month, expCategory, expAmount, expRemark} = this.state;
        if (!expCategory || expCategory.trim() === '') {
            message.warning("请填写支出类别");
            return;
        }
        if (expAmount == null) {
            message.warning("请填写有效的支出金额");
            return;
        }
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_EXPENSE_ADD_URL,
            params: {year, month, category: expCategory, amount: expAmount, remark: expRemark},
        }).then(res => {
            if (res.data.code === 200) {
                message.success("保存成功");
                this.setState({expCategory: '', expAmount: null, expRemark: ''});
                this.loadMonthData();
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    deleteExpense = (id) => {
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_EXPENSE_DELETE_URL,
            params: {id},
        }).then(res => {
            if (res.data.code === 200) {
                message.success("删除成功");
                this.loadMonthData();
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    startEditExpense = (row) => {
        this.setState({
            editVisible: true,
            editId: row.id,
            editYear: row.bizYear,
            editMonth: row.bizMonth,
            editCategory: row.category || '',
            editAmount: row.amount == null ? null : row.amount,
            editRemark: row.remark || '',
        });
    };

    updateEditField = (field, value) => {
        this.setState({[field]: value});
    };

    cancelEdit = () => {
        this.setState({
            editVisible: false, editId: null, editYear: null, editMonth: null,
            editCategory: '', editAmount: null, editRemark: '',
        });
    };

    saveExpenseEdit = () => {
        let {editId, editYear, editMonth, editCategory, editAmount, editRemark} = this.state;
        if (!editYear || !editMonth) {
            message.warning("请选择日期");
            return;
        }
        if (!editCategory || editCategory.trim() === '') {
            message.warning("请填写支出类别");
            return;
        }
        if (editAmount == null) {
            message.warning("请填写有效的支出金额");
            return;
        }
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_EXPENSE_UPDATE_URL,
            params: {id: editId, year: editYear, month: editMonth, category: editCategory, amount: editAmount, remark: editRemark},
        }).then(res => {
            if (res.data.code === 200) {
                message.success("保存成功");
                this.cancelEdit();
                this.loadMonthData();
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    loadAnnualReport = () => {
        let {annualYear} = this.state;
        if (!annualYear) return;
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_ANNUAL_REPORT_URL,
            params: {year: annualYear},
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({annual: res.data.data});
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    };

    exportAnnualReport = () => {
        let {annualYear} = this.state;
        if (!annualYear) return;
        Axios({
            method: 'get',
            url: PATH_URL.BOOKKEEPING_ANNUAL_REPORT_EXPORT_URL,
            params: {year: annualYear},
            responseType: 'blob',
        }).then(res => {
            const blob = new Blob([res.data]);
            const href = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = href;
            a.download = '年报表_' + annualYear + '.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(href);
        }).catch(err => console.log(err));
    };

    onTabChange = (key) => {
        this.setState({activeTab: key});
        if (key === 'report') {
            // 切到年报表页签总是重新拉取最新数据，数据变动后切回自动更新
            this.loadAnnualReport();
        }
    };

    yearOptions = () => {
        let cur = new Date().getFullYear();
        let opts = [];
        for (let y = 2020; y <= cur + 1; y++) opts.push(y);
        return opts.map(y => <Select.Option key={y} value={y}>{y}</Select.Option>);
    };

    monthOptions = () => {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            .map(m => <Select.Option key={m} value={m}>{m}月</Select.Option>);
    };

    renderIncomeEntry = () => {
        if (!this.hasPerm('160001')) return null;
        return (
            <div>
                <div style={{fontSize: 14, fontWeight: 600, margin: '8px 0'}}>收入（四大角色验车收入）</div>
                <Table
                    rowKey="incomeRole"
                    size="small"
                    pagination={false}
                    dataSource={this.state.income}
                    columns={[
                        {title: '角色', dataIndex: 'label', width: 90},
                        {
                            title: '台次', dataIndex: 'count', width: 90,
                            render: (v, r) => (
                                <InputNumber min={0} precision={0} style={{width: 72}} value={r.count}
                                             onChange={val => this.updateIncomeField(r.incomeRole, 'count', val)}/>
                            ),
                        },
                        {
                            title: '金额(元)', dataIndex: 'amount', width: 110,
                            render: (v, r) => (
                                <InputNumber min={0} precision={2} style={{width: 92}} value={r.amount}
                                             onChange={val => this.updateIncomeField(r.incomeRole, 'amount', val)}/>
                            ),
                        },
                        {
                            title: '操作', width: 60,
                            render: (v, r) => (
                                <Button type="primary" size="small" onClick={() => this.saveIncome(r)}>保存</Button>
                            ),
                        },
                    ]}
                />
            </div>
        );
    };

    renderExpenseEntry = () => {
        if (!this.hasPerm('160002')) return null;
        const {expFilterCategory, expFilterRemark} = this.state;
        const fc = (expFilterCategory || '').trim();
        const fr = (expFilterRemark || '').trim();
        const filteredExpenses = (this.state.expenses || []).filter(e =>
            (!fc || (e.category || '').includes(fc)) && (!fr || (e.remark || '').includes(fr)));
        const expenseCols = [
            {title: '类别', dataIndex: 'category', width: 120, render: v => v || '-'},
            {title: '金额(元)', dataIndex: 'amount', width: 100},
            {title: '备注', dataIndex: 'remark', render: v => v || '-'},
            ...(this.hasPerm('160003') || this.hasPerm('160005')
                ? [{
                    title: '操作', width: 110,
                    render: (v, r) => (
                        <span style={{display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap'}}>
                            {this.hasPerm('160005') ? <a onClick={() => this.startEditExpense(r)}>编辑</a> : null}
                            {this.hasPerm('160005') && this.hasPerm('160003') ? <Divider type="vertical"/> : null}
                            {this.hasPerm('160003') ?
                                <Popconfirm title="确认删除该笔支出？" onConfirm={() => this.deleteExpense(r.id)}>
                                    <a>删除</a>
                                </Popconfirm> : null}
                        </span>
                    ),
                }]
                : []),
        ];
        return (
            <div>
                <div style={{fontSize: 14, fontWeight: 600, margin: '8px 0'}}>支出</div>
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', marginBottom: '8px'}}>
                    <span style={{fontSize: 13}}>类别：</span>
                    <AutoComplete placeholder="支出类别" style={{width: 100}} allowClear
                                  value={this.state.expCategory}
                                  options={this.state.expCategoryOptions}
                                  getPopupContainer={trigger => trigger.parentElement}
                                  filterOption={(input, option) => (option.value || '').toUpperCase().includes((input || '').trim().toUpperCase())}
                                  onChange={val => this.setState({expCategory: val})}/>
                    <span style={{fontSize: 13}}>金额：</span>
                    <InputNumber precision={2} placeholder="金额" style={{width: 100}}
                                 value={this.state.expAmount}
                                 onChange={val => this.setState({expAmount: val})}/>
                    <span style={{fontSize: 13}}>备注：</span>
                    <Input placeholder="备注" style={{width: 130}} value={this.state.expRemark}
                           onChange={e => this.setState({expRemark: e.target.value})}/>
                    <Button type="primary" size="small" onClick={this.addExpense}>新增支出</Button>
                    <Divider type="vertical"/>
                    <span style={{fontSize: 13}}>筛选类别：</span>
                    <Input placeholder="按类别筛选" style={{width: 90}} allowClear value={this.state.expFilterCategory}
                           onChange={e => this.setState({expFilterCategory: e.target.value})}/>
                    <span style={{fontSize: 13}}>筛选备注：</span>
                    <Input placeholder="按备注筛选" style={{width: 120}} allowClear value={this.state.expFilterRemark}
                           onChange={e => this.setState({expFilterRemark: e.target.value})}/>
                </div>
                <Table rowKey="id" size="small" pagination={false} dataSource={filteredExpenses}
                       columns={expenseCols}/>
            </div>
        );
    };

    renderEntryTab = () => {
        return (
            <div>
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '8px'}}>
                    <span style={{fontSize: 13}}>记账月份：</span>
                    <Select style={{width: 110}} value={this.state.year}
                            onChange={y => this.setState({year: y}, this.loadMonthData)}>{this.yearOptions()}</Select>
                    <Select style={{width: 100}} value={this.state.month}
                            onChange={m => this.setState({month: m}, this.loadMonthData)}>{this.monthOptions()}</Select>
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start'}}>
                    <div style={{flex: 1, minWidth: 300}}>{this.renderIncomeEntry()}</div>
                    <div style={{flex: 2, minWidth: 520}}>{this.renderExpenseEntry()}</div>
                </div>
                <Divider/>
                <div style={{fontSize: 14, fontWeight: 600, margin: '8px 0'}}>当月汇总</div>
                {this.state.entrySummary ? this.renderMonthly(this.state.entrySummary) : null}
            </div>
        );
    };

    renderReportTab = () => {
        return (
            <div>
                {/* 年报表 */}
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '12px'}}>
                    <Select style={{width: 110}} value={this.state.annualYear}
                            onChange={y => this.setState({annualYear: y}, this.loadAnnualReport)}>{this.yearOptions()}</Select>
                    <Button type="primary" onClick={this.loadAnnualReport}>生成年报表</Button>
                </div>
                {this.state.annual ? this.renderAnnual(this.state.annual) : null}
            </div>
        );
    };

    fmtExpense = (v, r) => {
        if (r && r.negCount > 0) {
            return `${v}元(含负数${r.negTotal}元)`;
        }
        return `${v}元`;
    };

    renderMonthly = (m) => {
        const {monthlyExpCatFilter} = this.state;
        const fc = (monthlyExpCatFilter || '').trim();
        const filteredExpenseByCategory = (m.expenseByCategory || []).filter(r =>
            !fc || (r.category || '').includes(fc));
        const incomeCols = [
            {title: '收入角色', dataIndex: 'label', width: 110},
            {title: '台次', dataIndex: 'count', width: 80},
            {title: '金额(元)', dataIndex: 'amount', width: 110},
        ];
        const expenseCols = [
            {title: '支出类别', dataIndex: 'category', width: 140},
            {title: '金额(元)', dataIndex: 'amount', render: (v, r) => this.fmtExpense(v, r)},
        ];
        return (
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start'}}>
                <div style={{flex: 1, minWidth: 300}}>
                    {this.hasPerm('160001') ?
                        <Table size="small" pagination={false} rowKey="incomeRole"
                               dataSource={m.incomeByRole || []} columns={incomeCols}/> : null}
                    <div style={{fontSize: 13, marginTop: 8}}>
                        收入合计：<b style={{color: '#e6a23c'}}>{m.incomeTotal}</b> 元
                    </div>
                </div>
                <div style={{flex: 1, minWidth: 340}}>
                    {this.hasPerm('160002') ?
                        <div>
                            <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '8px'}}>
                                <span style={{fontSize: 13}}>支出类别筛选：</span>
                                <Input placeholder="输入支出类别关键词" style={{width: 180}} allowClear
                                       value={this.state.monthlyExpCatFilter}
                                       onChange={e => this.setState({monthlyExpCatFilter: e.target.value})}/>
                            </div>
                            <Table size="small" pagination={false} rowKey={(r) => r.category}
                                   dataSource={filteredExpenseByCategory} columns={expenseCols}/>
                        </div> : null}
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '24px', fontSize: 13, marginTop: 8}}>
                        <span>支出合计：<b style={{color: '#f56c6c'}}>{m.expenseTotal}</b> 元</span>
                        <span>结余：<b style={{color: '#409eff'}}>{m.net}</b> 元</span>
                    </div>
                </div>
            </div>
        );
    };

    renderAnnual = (a) => {
        const {annualExpFilter, annualIncFilter} = this.state;
        const fa = (annualExpFilter || '').trim();
        const fi = (annualIncFilter || '').trim();
        const filteredMonths = (a.months || []).filter(r => {
            if (fa) {
                const items = r.expenseByCategory || [];
                if (!items.some(i => (i.category || '').includes(fa))) return false;
            }
            if (fi) {
                const items = r.incomeByRole || [];
                if (!items.some(i => (i.label || '').includes(fi))) return false;
            }
            return true;
        });
        const cols = [
            {title: '月份', dataIndex: 'month', width: 80},
            {title: '收入合计', dataIndex: 'incomeTotal', width: 110},
            {title: '支出合计', dataIndex: 'expenseTotal', width: 110},
            {title: '结余', dataIndex: 'net', width: 110},
            {
                title: '操作', width: 90,
                render: (v, r) => (
                    <Button type="link" size="small"
                            onClick={() => this.setState({annualDetailVisible: true, annualDetailMonth: r})}>明细</Button>
                ),
            },
        ];
        return (
            <div>
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '8px'}}>
                    <span style={{fontSize: 13}}>支出类别筛选：</span>
                    <Input placeholder="输入支出类别关键词" style={{width: 160}} allowClear
                           value={this.state.annualExpFilter}
                           onChange={e => this.setState({annualExpFilter: e.target.value})}/>
                    <span style={{fontSize: 13}}>收入角色筛选：</span>
                    <Input placeholder="输入收入角色关键词" style={{width: 160}} allowClear
                           value={this.state.annualIncFilter}
                           onChange={e => this.setState({annualIncFilter: e.target.value})}/>
                    {this.hasPerm('160006') ?
                        <Button type="primary" size="small" style={{marginLeft: 'auto'}}
                                onClick={this.exportAnnualReport}>导出年报表</Button> : null}
                </div>
                <div className="annual-report-table">
                    <Table size="small" rowKey="month" pagination={false} dataSource={filteredMonths}
                           columns={cols}/>
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '24px', fontSize: 13}}>
                    <span>全年收入合计：<b style={{color: '#e6a23c'}}>{a.totals ? a.totals.incomeTotal : 0}</b> 元</span>
                    <span>全年支出合计：<b style={{color: '#f56c6c'}}>{a.totals ? a.totals.expenseTotal : 0}</b> 元</span>
                    <span>全年结余：<b style={{color: '#409eff'}}>{a.totals ? a.totals.net : 0}</b> 元</span>
                </div>
            </div>
        );
    };

    componentWillUnmount() {
        this.setState = () => {
        };
    }

    render() {
        // 当前用户实际可见的 tab keys（按展示顺序）；activeTab 若指向不存在的 pane（如只授权
        // 单个 tab 时初始值 'entry' 不在列表）则回退到第一个可见 tab，避免进入页面空白
        const tabKeys = [];
        if (this.hasPerm('160001') || this.hasPerm('160002')) tabKeys.push('entry');
        if (this.hasPerm('160004')) tabKeys.push('report');
        if (this.hasPerm('200017')) tabKeys.push('siteStat');
        if (this.hasPerm('200014')) tabKeys.push('siteSettle');
        if (this.hasPerm('200016')) tabKeys.push('siteChannel');
        if (this.hasPerm('200015')) tabKeys.push('siteRebate');
        const activeKey = tabKeys.includes(this.state.activeTab) ? this.state.activeTab
            : (tabKeys.length ? tabKeys[0] : undefined);
        return (
            <>
                <Tabs activeKey={activeKey} onChange={this.onTabChange}
                      style={{fontSize: 13}}>
                    {this.hasPerm('160001') || this.hasPerm('160002') ?
                        <Tabs.TabPane tab="流水录入" key="entry">{this.renderEntryTab()}</Tabs.TabPane> : null}
                    {this.hasPerm('160004') ?
                        <Tabs.TabPane tab="年报表" key="report">{this.renderReportTab()}</Tabs.TabPane> : null}
                    {this.hasPerm('200017') ?
                        <Tabs.TabPane tab="站点结算统计" key="siteStat"><SiteSettleManageInfo section="stat"/></Tabs.TabPane> : null}
                    {this.hasPerm('200014') ?
                        <Tabs.TabPane tab="结算记录" key="siteSettle"><SiteSettleManageInfo section="settle"/></Tabs.TabPane> : null}
                    {this.hasPerm('200016') ?
                        <Tabs.TabPane tab="特殊渠道" key="siteChannel"><SiteSettleManageInfo section="channel"/></Tabs.TabPane> : null}
                    {this.hasPerm('200015') ?
                        <Tabs.TabPane tab="返点设置" key="siteRebate"><SiteSettleManageInfo section="rebate"/></Tabs.TabPane> : null}
                </Tabs>
                <Modal title="编辑支出" visible={this.state.editVisible}
                       onOk={this.saveExpenseEdit} onCancel={this.cancelEdit}
                       okText="保存" cancelText="取消" width={420}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        <div>
                            <span style={{fontSize: 13}}>日期：</span>
                            <Select style={{width: 100}} value={this.state.editYear}
                                    onChange={y => this.updateEditField('editYear', y)}>{this.yearOptions()}</Select>
                            <Select style={{width: 90, marginLeft: 8}} value={this.state.editMonth}
                                    onChange={m => this.updateEditField('editMonth', m)}>{this.monthOptions()}</Select>
                        </div>
                        <div>
                            <span style={{fontSize: 13}}>类别：</span>
                            <Input style={{width: 200}} value={this.state.editCategory}
                                   onChange={e => this.updateEditField('editCategory', e.target.value)}/>
                        </div>
                        <div>
                            <span style={{fontSize: 13}}>金额：</span>
                            <InputNumber precision={2} style={{width: 200}} value={this.state.editAmount}
                                         onChange={v => this.updateEditField('editAmount', v)}/>
                        </div>
                        <div>
                            <span style={{fontSize: 13}}>备注：</span>
                            <Input style={{width: 200}} value={this.state.editRemark}
                                   onChange={e => this.updateEditField('editRemark', e.target.value)}/>
                        </div>
                    </div>
                </Modal>
                <Modal title={this.state.annualDetailMonth ? this.state.annualDetailMonth.month + '月 明细' : '月份明细'}
                       visible={this.state.annualDetailVisible} footer={null}
                       onCancel={() => this.setState({annualDetailVisible: false, annualDetailMonth: null})}
                       width={620}>
                    {this.state.annualDetailMonth ? (() => {
                        const dm = this.state.annualDetailMonth;
                        return (
                            <div>
                                <div style={{fontSize: 13, fontWeight: 600, margin: '8px 0'}}>收入明细</div>
                                <Table size="small" pagination={false} rowKey="label"
                                       dataSource={dm.incomeByRole || []}
                                       columns={[
                                           {title: '收入角色', dataIndex: 'label', width: 160},
                                           {title: '台次', dataIndex: 'count', width: 90},
                                           {title: '金额(元)', dataIndex: 'amount', width: 130},
                                       ]}/>
                                <div style={{fontSize: 13, fontWeight: 600, margin: '8px 0'}}>支出明细</div>
                                <Table size="small" pagination={false} rowKey={(r) => r.category}
                                       dataSource={dm.expenseByCategory || []}
                                       columns={[
                                           {title: '支出类别', dataIndex: 'category', width: 200},
                                           {title: '金额(元)', dataIndex: 'amount', render: (v, r) => this.fmtExpense(v, r)},
                                       ]}/>
                                <div style={{display: 'flex', flexWrap: 'wrap', gap: '24px', fontSize: 13, marginTop: 8}}>
                                    <span>收入合计：<b style={{color: '#e6a23c'}}>{dm.incomeTotal}</b> 元</span>
                                    <span>支出合计：<b style={{color: '#f56c6c'}}>{dm.expenseTotal}</b> 元</span>
                                    <span>结余：<b style={{color: '#409eff'}}>{dm.net}</b> 元</span>
                                </div>
                            </div>
                        );
                    })() : null}
                </Modal>
            </>
        );
    }
}

export default BookkeepingManageInfo;